import { combineReducers } from 'redux'
import _ from 'lodash'

import * as list from './list'
import * as get from './get'
import * as generate from './generate'
import * as edit from './edit'
import * as exportClaim from './export'
import * as downloadExport from './downloadExport'
import * as deleteClaim from './delete'
import * as eligibleResidents from './eligibleResidents'

import * as nextPeriod from './nextPeriod'
import * as excludeResident from './excludeResident'
import * as includeResident from './includeResident'
import * as regenerate from './regenerate'
import * as lock from './lock'

const slices = {
  list,
  get,
  generate,
  edit,
  exportClaim,
  downloadExport,
  deleteClaim,
  eligibleResidents,
  nextPeriod,
  excludeResident,
  includeResident,
  regenerate,
  lock
}

const medicalClaimTypes = _.mapValues(slices, (s) => s.slice.types)
const medicalClaimActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const medicalClaimSagas = _(slices).values().map('slice.sagas').flatten().value()
const medicalClaimSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { medicalClaimTypes, medicalClaimActions, medicalClaimSagas, medicalClaimSelectors }

export default combineReducers(reducers)
